import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu as MenuIcon, X, Flame } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/business";

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-2.5 group" aria-label="Bakso Tujuh Pemuda — Beranda">
    <span className="w-9 h-9 rounded-full bg-terracotta text-cream flex items-center justify-center font-display font-black text-sm leading-none transition-transform duration-500 group-hover:rotate-12">
      7
    </span>
    <span className={`font-display font-black text-lg leading-none tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
      Bakso Tujuh<br />
      <span className="italic font-semibold text-terracotta">Pemuda</span>
    </span>
  </Link>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="bg-leaf-deep text-cream/90 text-xs sm:text-sm" data-testid="top-info-bar">
        <div className="max-w-6xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2">
          <Flame size={13} className="text-amberbrand shrink-0" />
          <span>Buka setiap hari 09.00–21.00 WIB · {BUSINESS.address.street}, Bogor Tengah</span>
        </div>
      </div>
      <nav className="bg-cream/85 backdrop-blur-xl border-b border-line" aria-label="Navigasi utama">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <Logo />
          <div className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
                    isActive ? "bg-terracotta text-cream" : "text-ink-soft hover:text-terracotta"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={BUSINESS.links.orderOnline}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-order-online-button"
              className="ml-2 px-5 py-2.5 rounded-full bg-terracotta text-cream text-sm font-bold hover:bg-terracotta-dark transition-colors duration-300"
            >
              Pesan Online
            </a>
          </div>
          <button
            className="md:hidden p-2 text-ink"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Tutup menu" : "Buka menu"}
            aria-expanded={open}
          >
            {open ? <X size={24} /> : <MenuIcon size={24} />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="md:hidden bg-cream border-b border-line shadow-xl" data-testid="mobile-nav-panel">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl font-semibold ${isActive ? "bg-terracotta text-cream" : "text-ink hover:bg-tint"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={BUSINESS.links.orderOnline}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-order-online-button"
              className="mt-2 px-4 py-3 rounded-xl bg-terracotta text-cream font-bold text-center"
            >
              Pesan Online
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
